import $ from 'jquery';

(function ($) {
  var $viewport = $("html, body");

  // Plugin definition.
  $.fn.diaAnchor = function(options) {
    return this.each(function() {
      var $el = $(this);

      var defaults = {
        scrollSpeed: 200,
        offset: 0
      };
      var settings = $.extend({}, defaults, $.fn.diaAnchor.defaults, options, $el.data());
      if((typeof settings.offset) == 'function') {
        settings.offset = settings.offset();
      }

      var $target = settings.parent && $(settings.parent).length>0 ? $(settings.parent) : $el;
      var offsetTop = parseInt($target.offset().top - settings.offset);
      if(offsetTop<0) offsetTop = 0;

      $viewport.stop().animate({ scrollTop: offsetTop }, settings.scrollSpeed);
    });
  };

  // Plugin defaults – added as a property on our plugin function.
  $.fn.diaAnchor.defaults = {};

  $(function() {

    var options = {
      offset: 0
    };

    var $pageHeader = $('.page-header');

    if($pageHeader.length) {
      options.offset = ($pageHeader.height() + 36);
    }

    // stop scroll event on mousewheel
    $viewport.bind("scroll mousedown wheel DOMMouseScroll mousewheel keyup", function(e){
      if ( e.which > 0 || e.type === "mousedown" || e.type === "mousewheel"){
        $viewport.stop();
      }
    });

    function cleanUrl(url) {
      return url.indexOf("#")>=0 ? url.substr(0, url.indexOf("#")) : url;
    }

    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[class1^=mm-]')
        .not('[data-toggle="collapse"]')
    .click( function(e) {
      var $this = $(this),
          current = window.location.href,
          target = e.currentTarget.href,
          targetHash = e.currentTarget.hash;

      /*
      var dataTarget = $this.attr('data-target');
      if(typeof dataTarget !== 'undefined') {
        var $target = $(targetHash),
            parent = $target.attr('data-parent');

        if(typeof parent !== 'undefined') {
          var $parent = $(parent);

          if($parent.length>0) {
            $parent.collapse('hide');
          }
        }

        targetHash = dataTarget;
      }
      */

      if(cleanUrl(current)==cleanUrl(target)) {
        e.preventDefault();
        if(window.history.pushState) {
          window.history.pushState(null, null, targetHash);
        } else {
          window.location.hash = targetHash;
          $(window).trigger('hashchange');
        }
        $(targetHash).diaAnchor(options);
      }
    });

    // scroll on hashchange
    $(window).on('hashchange', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var $el = $(window.location.hash);

      $el.collapse('show')
          .diaAnchor(options);
    });

    // scroll on page load
    if(window.location.hash.length>0) {
      $(window).trigger('hashchange');
    }
  });

})(jQuery);